import * as React from 'react';
import { Link } from 'react-router-dom';

import ImageWallet from '@/assets/images/guide/img_nav_wallet.png';
import ImageWalletWebp from '@/assets/images/guide/img_nav_wallet.png?webp';
import ImageWallet2x from '@/assets/images/guide/img_nav_wallet@2x.png';
import ImageWallet2xWebp from '@/assets/images/guide/img_nav_wallet@2x.png?webp';
import Button from '@/components/elements/Button/BaseButton';
import Image from '@/components/elements/Image';
import { TextExternalLink } from '@/components/elements/Text/TextLink';
import {
  PAYOUT_BANK_HELP_URL,
  WALLET_HELP_URL,
} from '@/config/constants/guide';
import { GuidePageTitles } from '@/pages/Guide/types';

import { HASH_PAYOUT } from '../../Wallet';
import {
  ButtonContainer,
  Container,
  ContentBox,
  Text,
  TextLarge,
  TextNote,
  Title,
  TitleSmall,
} from '../style';
import { Card, CardInnerList, CardWrapper, ImageBox, Note } from './style';

const GuideWalletTemplate: React.FC = () => {
  return (
    <Container>
      <ContentBox>
        <Title>{GuidePageTitles.Wallet}</Title>
        <TextLarge>
          「入金/払戻金残高」とは、DMM競輪で投票ができる預かり金です。
          <br />
          いつでも入金や精算（出金）が可能です。
        </TextLarge>
        <ImageBox>
          <Image
            srcSet={`${ImageWallet} 1x, ${ImageWallet2x} 2x`}
            mediaSet={[
              {
                srcSet: `${ImageWalletWebp} 1x, ${ImageWallet2xWebp} 2x`,
                type: 'image/webp',
              },
            ]}
            alt="入金/払戻金残高"
            width={['auto', 'auto', '400px', '400px']}
            aspectRatio={295 / 800}
          />
          <TextNote>
            <i>※</i>画像はスマートフォン版のものです。
          </TextNote>
        </ImageBox>
        <CardWrapper>
          <Card>
            <TitleSmall>入金</TitleSmall>
            <Text>以下の方法で入金することができます。</Text>
            <CardInnerList>
              <li>・銀行振込</li>
              <li>・ATM決済</li>
            </CardInnerList>
            <Text>
              また、的中した払戻金も自動的に入金/払戻金残高へ入金されます。
            </Text>
            <ButtonContainer>
              <Link to="/wallet">
                <Button
                  type="button"
                  outline
                  bgColor="primary"
                  size="m"
                  radius="l"
                  height="56px"
                  fontWeight="bold"
                >
                  入金する
                </Button>
              </Link>
            </ButtonContainer>
          </Card>
          <Card>
            <TitleSmall>精算</TitleSmall>
            <Text>
              入金/払戻金残高は、登録されている銀行口座へいつでも精算（出金）が可能です。
              <br />
              入金/払戻金残高からtoreta+ へチャージすることもできます。
              <br />
              銀行口座への振込スケジュールにつきましては
              <TextExternalLink href={PAYOUT_BANK_HELP_URL} fontWeight="normal">
                こちら
              </TextExternalLink>
              をご確認ください。
            </Text>
            <ButtonContainer>
              <Link to={`/wallet#${HASH_PAYOUT}`}>
                <Button
                  type="button"
                  outline
                  bgColor="primary"
                  size="m"
                  radius="l"
                  height="56px"
                  fontWeight="bold"
                >
                  精算する
                </Button>
              </Link>
            </ButtonContainer>
          </Card>
        </CardWrapper>
        <TitleSmall>投票時にその場でチャージができる！</TitleSmall>
        <Text>
          投票時にtoreta+
          残高が不足しているとき、入金/払戻金残高からその場でチャージして投票することもできます。ぜひご活用ください。
        </Text>
        <Note>
          その他ご不明な点につきましては、
          <TextExternalLink href={WALLET_HELP_URL}>
            よくある質問
          </TextExternalLink>
          をご確認ください。
        </Note>
      </ContentBox>
    </Container>
  );
};

export default GuideWalletTemplate;
